import { render, staticRenderFns } from "./Reductions.vue?vue&type=template&id=11e4de95&scoped=true"
import script from "./Reductions.vue?vue&type=script&lang=js"
export * from "./Reductions.vue?vue&type=script&lang=js"
import "./Reductions.vue?vue&type=style&index=0&id=11e4de95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e4de95",
  null
  
)

export default component.exports